import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PortfolioService } from '@services/portfolio/portfolio.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class PortfolioGuardService {

  constructor(private portfolioService: PortfolioService, private router: Router) {
  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkPortfolioUser(route)
      .then((e) => {
      if (e) {
        return true;
      }
    })
      .catch(() => {
        this.router.navigate(['/portfolios']);
        return false;
      });
  }

  checkPortfolioUser(route: any): Promise<boolean> {
    const portfolioID = route.params['id'];

    return this.portfolioService.GetPortfolioByID(portfolioID).pipe(
      map((res: any) => {
        if (res.json.data != null) {
          return true;
        } else {
          this.router.navigate(['/portfolios']);
          return false;
        }
      })).toPromise();
  };
}
